export default "__VITE_ASSET__DkmZsRxw__"